import { emojis } from "./emoji_icons";

(function ($R) {
  $R.add("plugin", "emoji", {
    init: function (app) {
      this.app = app;
      this.toolbar = app.toolbar;
      this.marker = app.marker;
      this.selection = app.selection;
    },
    start: function () {
      let data = {
        title: "emoji",
        api: "plugin.emoji.toggle_emoji",
      };

      let imageUrls = emojis.set1.map((obj) => obj.image);

      let button = this.toolbar.addButton("emojis", data);
      let emojiBtn = button.nodes[0];

      let emojiBtnImg = `<img src="https://cdn1.pepper.ru/static/images/emojis/happy.svg" alt="happy" loading="lazy">`;

      let innerContent = `
        <div class="emoji-section">
            <div class="tab-toggler-section">
                <button class="recentTabBtn flex justify-center emoji-tab">
                    <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                    </svg>                                     
                </button>
                <button class="emojiTabBtn emoji-tab flex justify-center items-center ico ico-happy active">
                    ${I18n.t("emoji")}
                </button>
                <button class="elementTabBtn emoji-tab flex justify-center ico ico-star-full">
                    <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M13.849 4.22c-.684-1.626-3.014-1.626-3.698 0L8.397 8.387l-4.552.361c-1.775.14-2.495 2.331-1.142 3.477l3.468 2.937-1.06 4.392c-.413 1.713 1.472 3.067 2.992 2.149L12 19.35l3.897 2.354c1.52.918 3.405-.436 2.992-2.15l-1.06-4.39 3.468-2.938c1.353-1.146.633-3.336-1.142-3.477l-4.552-.36-1.754-4.17Z"/>
                    </svg>                                     
                </button>
            </div>
            <div class="toggle-section">
                <div class="emoji-recentTab"></div>
                <div class="emoji-emojiTab active">
                    ${imageUrls
                      .map(
                        (img) =>
                          `<button><img class="editor-emojiImg" loading="lazy" src="${img}"></button>`
                      )
                      .join("")}
                </div>
                <div class="emoji-elementTab"></div>
            </div>
        </div>`;
      emojiBtn.innerHTML = emojiBtnImg + innerContent;

      let is = this.app.editor.isSourceMode();
      let redactorDropdown = document.querySelector(".redactor-dropdown");

      if (redactorDropdown && redactorDropdown.classList.contains("open")) {
        redactorDropdown.classList.add("redactor-animate-hide");
      }

      let rApp = this.app;
      let emojiIcons = emojiBtn.querySelectorAll(".toggle-section button");

      emojiIcons.forEach((icon) => {
        icon.addEventListener("click", function () {
          rApp.plugin.emoji.add_emoji(this);
        });
      });

      document.addEventListener("click", function (e) {
        let emojiSection = document.querySelector(".re-emojis .emoji-section");

        if (emojiSection?.classList.contains("open")) {
          if (!e.target.closest(".re-emojis")) {
            emojiSection.classList.remove("open");
            document.querySelector(
              ".redactor-box.redactor-styles-on .redactor-toolbar-wrapper .redactor-toolbar"
            ).style.overflow = "";
          } else {
            document.querySelector(
              ".redactor-box.redactor-styles-on .redactor-toolbar-wrapper .redactor-toolbar"
            ).style.overflow = "visible";
          }
        }
      });

      let recentTabBtn = emojiBtn.querySelector(".recentTabBtn");
      let emojiTabBtn = emojiBtn.querySelector(".emojiTabBtn");
      let elementTabBtn = emojiBtn.querySelector(".elementTabBtn");
      let recentTab = emojiBtn.querySelector(".emoji-recentTab");
      let emojiTab = emojiBtn.querySelector(".emoji-emojiTab");
      let elementTab = emojiBtn.querySelector(".emoji-elementTab");

      recentTabBtn.addEventListener("click", () =>
        rApp.plugin.emoji.recent_tab(
          recentTabBtn,
          emojiTabBtn,
          elementTabBtn,
          recentTab,
          emojiTab,
          elementTab
        )
      );
      emojiTabBtn.addEventListener("click", () =>
        rApp.plugin.emoji.emoji_tab(
          emojiTabBtn,
          recentTabBtn,
          elementTabBtn,
          recentTab,
          emojiTab,
          elementTab
        )
      );
      elementTabBtn.addEventListener("click", () =>
        rApp.plugin.emoji.element_tab(
          elementTabBtn,
          recentTabBtn,
          emojiTabBtn,
          recentTab,
          emojiTab,
          elementTab
        )
      );
    },
    toggle_emoji: function () {
      let emojis = this.toolbar.getButton("emojis");
      let emojiBtn = emojis.nodes[0];
      let emojiSection = emojiBtn.querySelector(".emoji-section");
      emojiSection.classList.toggle("open");
    },
    add_emoji: function (btn) {
      let emojiImg = btn.querySelector("img").cloneNode(true);
      emojiImg.setAttribute("contenteditable", "true");

      let selection = window.getSelection();
      let range = selection.getRangeAt(0);
      range.insertNode(emojiImg);

      let spaceNode = document.createTextNode(" ");
      range.setStartAfter(emojiImg);
      range.insertNode(spaceNode);
      range.setStartAfter(spaceNode);
      range.setEndAfter(spaceNode);
      selection.removeAllRanges();
      selection.addRange(range);

      this.app.editor.focus();
      document.querySelector(
        ".redactor-box.redactor-styles-on .redactor-toolbar-wrapper .redactor-toolbar"
      ).style.overflow = "";
    },
    recent_tab: function (
      btn,
      emojiTabBtn,
      elementTabBtn,
      recentTab,
      emojiTab,
      elementTab
    ) {
      event.preventDefault();
      event.stopPropagation();
      elementTabBtn.classList.remove("active");
      emojiTabBtn.classList.remove("active");
      btn.classList.add("active");
      emojiTab.classList.remove("active");
      elementTab.classList.remove("active");
      recentTab.classList.add("active");
    },
    emoji_tab: function (
      btn,
      recentTabBtn,
      elementTabBtn,
      recentTab,
      emojiTab,
      elementTab
    ) {
      event.preventDefault();
      event.stopPropagation();
      elementTabBtn.classList.remove("active");
      recentTabBtn.classList.remove("active");
      btn.classList.add("active");
      recentTab.classList.remove("active");
      elementTab.classList.remove("active");
      emojiTab.classList.add("active");
    },
    element_tab: function (
      btn,
      recentTabBtn,
      emojiTabBtn,
      recentTab,
      emojiTab,
      elementTab
    ) {
      event.preventDefault();
      event.stopPropagation();
      emojiTabBtn.classList.remove("active");
      recentTabBtn.classList.remove("active");
      btn.classList.add("active");
      recentTab.classList.remove("active");
      emojiTab.classList.remove("active");
      elementTab.classList.add("active");
    },
  });
})(Redactor);
